export * from './public_api';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /Users/azerty/friendlychat-web/cloud-functions-angular-start/~/angularfire2/auth/index.js
// module id = ../../../../angularfire2/auth/index.js
// module chunks = 3